module.exports = __webpack_public_path__ + "static/media/1.a5236292.jpg";